import { useCommonData } from '@/hooks';
import { ref, computed } from 'vue';

export const useEventIntercept = () => {
	const { viewInIframe } = useCommonData();
	const disabledClick = computed(() => viewInIframe.value);

	// 点击事件拦截相关
	const nodeContainer = ref(null);

	// 拦截过滤配置 - 这些类名及其子节点不会被拦截
	const clickInterceptFilterClasses = ref([
		// Flow
		'.header-banner',
		'.home-nav-component',
		'.footer-component',
		'.fixed-operate-wrapper',

		// FlowX
		'.layout-menu-bar',

		// Slide
		'.slide-menu',
		'.el-tabs__header',

		// Surf
		'.nav-container',
		'.overview-module-footer',
		'.footer-container'
	]);

	// 检查元素或其父元素是否包含过滤类名
	const isElementInFilterList = (element, filterClasses) => {
		if (!element) return false;

		// 检查当前元素
		for (const filterClass of filterClasses) {
			const className = filterClass.startsWith('.') ? filterClass.slice(1) : filterClass;
			if (element.classList && element.classList.contains(className)) {
				return true;
			}
		}

		// 递归检查父元素
		if (element.parentElement && element.parentElement !== nodeContainer.value) {
			return isElementInFilterList(element.parentElement, filterClasses);
		}

		return false;
	};

	// 点击事件拦截处理函数
	const handleClickIntercept = event => {
		if (!disabledClick.value) return;

		const { target } = event;

		// 检查点击目标是否在过滤列表中
		const isFiltered = isElementInFilterList(target, clickInterceptFilterClasses.value);

		if (!isFiltered) {
			// 阻止事件的默认行为和冒泡
			event.preventDefault(); // 第1层：阻止元素本身的功能
			event.stopPropagation(); // 第2层：阻止事件向上传递
			event?.stopImmediatePropagation(); // 第3层：阻止同级竞争监听器

			// 打印说明信息
			console.log('🚫 点击事件已被拦截:', {
				target: target,
				tagName: target.tagName,
				className: target.className,
				reason: '当前处于 iframe 预览模式，点击功能已被禁用',
				disabledClick: disabledClick.value
			});
		}
	};

	// 添加点击事件拦截监听器
	const addEventIntercept = () => {
		if (nodeContainer.value) {
			nodeContainer.value.addEventListener('click', handleClickIntercept, true); // 使用捕获阶段
		}
	};
	const removeEventIntercept = () => {
		if (nodeContainer.value) {
			nodeContainer.value.removeEventListener('click', handleClickIntercept, true);
		}
	};

	return {
		nodeContainer,
		handleClickIntercept,
		addEventIntercept,
		removeEventIntercept
	};
};
